export function createFormspreeSubmitter(formspreeUrl) {
  return async ({ path, data, def }) => {
    const payload = {
      form: path,
      subject: def?.subject || "New message",
      ...data,
    };

    const res = await fetch(formspreeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      let msg = "Could not send. Try again.";
      try {
        const j = await res.json();
        msg = j?.errors?.[0]?.message || msg;
      } catch {}
      throw new Error(msg);
    }
  };
}
